import React from 'react';
import './Dashboard.scss';
import { Logout } from '../../components/Logout/Logout';
import { Link } from 'react-router-dom';
import { FiList } from 'react-icons/fi';
import { GoPlus } from 'react-icons/go';

export const Dashboard = () => {
	return (
		<div className='Dashboard'>
			<div className='container'>
				<Logout />
				<br />
				<h1>Dashboard</h1>

				{/* ABOUT */}
				<Link to='/create-category-about'>
					<div>
						<GoPlus />
						<h4>Crear categoría de I.B.</h4>
					</div>
				</Link>

				<Link to='/list-categories-about'>
					<div>
						<FiList />
						<h4>Listado de categorías de I.B.</h4>
					</div>
				</Link>

				{/* BDC */}
				<Link to='/create-category-bdc'>
					<div>
						<GoPlus />
						<h4>Crear categoría de B.D.C.</h4>
					</div>
				</Link>

				<Link to='/list-categories-bdc'>
					<div>
						<FiList />
						<h4>Listado de categorías de B.D.C.</h4>
					</div>
				</Link>

				{/* PROJECTS */}
				<Link to='/create-project'>
					<div>
						<GoPlus />
						<h4>Crear un proyecto</h4>
					</div>
				</Link>

				<Link to='/list-projects'>
					<div>
						<FiList />
						<h4>Listado de proyectos</h4>
					</div>
				</Link>

				{/* STUDIO */}
				<Link to='/create-category-studio'>
					<div>
						<GoPlus />
						<h4>Crear categoría de Estudio</h4>
					</div>
				</Link>

				<Link to='/list-categories-studio'>
					<div>
						<FiList />
						<h4>Listado de categorías de Estudio</h4>
					</div>
				</Link>
			</div>
		</div>
	);
};
